import { defineStore } from 'pinia';
import * as authApi from '../api/auth';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    // 用户信息
    userInfo: null,
    // 登录状态
    isLoggedIn: false,
    // 加载状态
    loading: false,
  }),

  getters: {
    // 获取用户角色
    userRole: (state) => state.userInfo?.role || '',
    // 判断是否为管理员
    isAdmin: (state) => state.userInfo?.role === 'admin',
    // 判断是否为员工
    isEmployee: (state) => state.userInfo?.role === 'employee',
    // 判断是否为超级管理员
    isSuperAdmin: (state) => state.userInfo?.is_super_admin === true,
  },

  actions: {
    // 初始化状态
    initState() {
      try {
        const token = localStorage.getItem('token');
        const userInfoStr = localStorage.getItem('userInfo');
        
        if (token) {
          this.isLoggedIn = true;
          
          if (userInfoStr) {
            try {
              this.userInfo = JSON.parse(userInfoStr);
            } catch (e) {
              console.error('解析userInfo失败:', e);
              this.userInfo = null;
              localStorage.removeItem('userInfo');
              localStorage.removeItem('token');
            }
          }
        }
      } catch (e) {
        console.error('初始化状态失败:', e);
        // 重置状态
        this.userInfo = null;
        this.isLoggedIn = false;
        localStorage.removeItem('userInfo');
        localStorage.removeItem('token');
      }
    },
    // 登录
    async login(credentials) {
      this.loading = true;
      try {
        let response;
        // 目前只支持管理员登录
        response = await authApi.adminLogin(credentials);

        // 保存token和用户信息到localStorage
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('userInfo', JSON.stringify(response.data.user));

        // 更新状态
        this.userInfo = response.data.user;
        this.isLoggedIn = true;

        // 登录成功后获取菜单数据
        try {
          // 动态导入menu store，避免循环依赖
          const { useMenuStore } = require('./menu');
          const menuStore = useMenuStore();
          await menuStore.initMenus();
        } catch (menuError) {
          console.error('获取菜单数据失败:', menuError);
          // 菜单获取失败不影响登录成功
        }

        return response;
      } catch (error) {
        console.error('登录失败:', error);
        throw error;
      } finally {
        this.loading = false;
      }
    },

    // 登出
    async logout() {
      try {
        await authApi.adminLogout();
      } catch (error) {
        console.error('登出失败:', error);
      } finally {
        // 清除localStorage和状态
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo');
        this.userInfo = null;
        this.isLoggedIn = false;
      }
    },

    // 获取当前用户信息
    async getCurrentUser() {
      try {
        const response = await authApi.getAdminInfo();
        this.userInfo = response.data;
        localStorage.setItem('userInfo', JSON.stringify(response.data));
        return response;
      } catch (error) {
        console.error('获取用户信息失败:', error);
        throw error;
      }
    },

    // 更新用户信息
    updateUserInfo(info) {
      this.userInfo = { ...this.userInfo, ...info };
      localStorage.setItem('userInfo', JSON.stringify(this.userInfo));
    },
  },
});
